import React from 'react'
import styled from 'styled-components'

const HoneyPotWrapper = styled.div`
  display: none;
`
class HoneyPot extends React.Component {

  render(){
    const { fullName, confirmEmail, handleInputChange } = this.props

    return(
      <HoneyPotWrapper>
        <label
          htmlFor="fullName"
        >
          Leave this field empty!
        </label>
        <input
          className='flex-1 bg-white font-mono text-sm lg:text-base appearance-none border-2 border-secondary-light w-full py-1 lg:py-2 px-2 lg:px-4 text-primary leading-tight focus:outline-none focus:bg-white font-mono focus:border-primary'
          type="text"
          name="fullName"
          aria-label="Full Name"
          value={fullName}
          onChange={handleInputChange}
          placeholder="Full Name"
        />
        <label
          htmlFor="confirmEmail"
        >
          Leave this field empty!
        </label>
        <input
          className='flex-1 bg-white font-mono text-sm lg:text-base appearance-none border-2 border-secondary-light w-full py-1 lg:py-2 px-2 lg:px-4 text-primary leading-tight focus:outline-none focus:bg-white font-mono focus:border-primary'
          type="email"
          name="confirmEmail"
          aria-label="Confirm Email"
          value={confirmEmail}
          onChange={handleInputChange}
          placeholder="Confirm Email"
        />
      </HoneyPotWrapper>
    )
  }
}

export default HoneyPot
